import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { ENVIRONMENT_INJECTION_TOKEN } from '@sbd-doug-frontend/shared/lib/injections/environment-injection-token';

export interface QuoteRequestTaskAssociation {
  uri?: string;
  result_uri?: string;
  order_number?: string;
  bond_label?: string;
  client_name?: string;
  principal_name?: string;
  client_phone?: string;
  client_email?: string;
  quote_request_id?: number;
  quote_request_access_url?:string
}

@Component({
  selector: 'app-quote-request-task-association-view',
  standalone: true,
  imports: [
    MatIcon,
    MatIconButton,
    MatTooltip,
  ],
  templateUrl: './quote-request-task-association-view.component.html',
})
export class QuoteRequestTaskAssociationViewComponent {
  @Output() disassociateQuoteRequestEvent = new EventEmitter<void>();
  @Input() quoteRequestTaskAssociation!: QuoteRequestTaskAssociation;
  private _environment = inject(ENVIRONMENT_INJECTION_TOKEN);

  onDetachQuoteRequestEvent() {
    this.disassociateQuoteRequestEvent.emit();
  }

  formatUri() {

    if(this.quoteRequestTaskAssociation?.quote_request_access_url){
      return this.quoteRequestTaskAssociation?.quote_request_access_url;
    }

    if(this.quoteRequestTaskAssociation?.result_uri){
      return this._environment.dougV2BaseUrl + this.quoteRequestTaskAssociation?.result_uri;
    }

    return this._environment.dougV2BaseUrl + this.quoteRequestTaskAssociation?.uri;
  }

  get url(): string {
    return this.formatUri();
  }
}
